export default __webpack_public_path__ + "static/media/aboutus_illustration2.1d807889.gif";